import axios from 'axios';
import { LoadConfig } from '../utils/loadConfig';

const api = axios.create({
  baseURL: LoadConfig().REACT_APP_API,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  },
});

export default api;
